/**
 * auth模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '../request/http'; // 导入http中创建的axios实例
import store from '../store';
// import qs from 'qs'; // 根据需求是否导入qs模块

const filter = {
    // 获取颜色
    color (params) {
        return axios.get(`${base.dev}/couleurs_efashion`,{params:params});
    },
    // 获取产地
    provenance (params) {
        return axios.get(`${base.dev}/provenances`,{params:params});
    },
    // 获取产地
    getVendeurProvenances (query) {
        return axios.get(`${base.dev}/v2/vendeurs/produits/getVendeurProvenances`,{params:query});
    },
    // 获取collections
    collections (params) {
        return axios.get(`${base.dev}/collections`,{params:params});
    },
    // 获取特性
    caracteristiques (params) {
        if (!params.id_langue) params.id_langue = store.state.lang;
        return axios.get(`${base.dev}/v2/vendeurs/produits/getCaracteristiques`,{params:params});
    },
    // 获取品牌
    marques (params) {
        return axios.get(`${base.dev}/v2/vendeurs/getVendeurMarquesFilter`,{params:params});
    },
    // 获取产品组成
    compositions (params) {
        if (!params.id_langue) params.id_langue = store.state.lang;
        return axios.get(`${base.dev}/v2/vendeurs/produits/getCompositions`,{params:params});
    },


    // 其他接口…………
}

export default filter;

